import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatus } from '@ms/yammer-data-support';

import type { StorylinePublisherSettings, YammerState } from '../../state/types';

type GetStorylinePublisherSettings = (state: YammerState) => StorylinePublisherSettings | undefined;
/**
 * @deprecated PERFORMANCE This returns an entire fulfilled settings object and will force re-renders if the settings
 * get updated. This should be replaced by primitive value selectors for individual settings.
 */
export const getStorylinePublisherSettings: GetStorylinePublisherSettings = (state: YammerState) =>
  state.storylinePublisherSettings.fulfilled;

type GetStorylinePublisherSettingsStatus = (state: YammerState) => EntityStatus;
export const getStorylinePublisherSettingsStatus: GetStorylinePublisherSettingsStatus = (state) =>
  getStatus(state.storylinePublisherSettings);
